import { useState } from 'react';
import { Document, Page } from 'react-pdf';

import manualPdf from '../../../../assets/doc/manual-de-instalacao-da-impressora-de-checklist.pdf'
export function Manual() {
  const [numPages, setNumPages] = useState()

  return (
    <div className="flex flex-col gap-6 p-2 bg-white rounded border border-zinc-200/40 shadow">
      <div className="flex flex-col gap-2 group h-full w-full">
        <div data-active="false" className="flex items-center gap-4 p-2 rounded flex-col">
          <p className="text-center w-full">Para começar a usar o <strong className="font-bold">checklist impresso</strong> na sua loja, você precisa ativá-lo e seguir o passo a passo descrito no <a href='/docs/manual-de-instalacao-da-impressora-de-checklist.pdf' target="_blank" className="font-bold text-primary hover:underline">manual</a>.</p>
          <div className='w-full'>
            <Document file="/docs/manual-de-instalacao-da-impressora-de-checklist.pdf" onLoadSuccess={(pdf) => { setNumPages(pdf.numPages) }} className="flex flex-col w-full gap-2 [&_canvas]:!w-full [&_canvas]:!h-auto">
              {_.range(numPages).map((index) => (
                <Page key={`page_${index + 1}`} pageNumber={index + 1} width={600} renderTextLayer={false} renderAnnotationLayer={false} />
              ))}
            </Document>
          </div>
        </div>
      </div>
    </div>
  )
}
